import React, { Fragment } from "react";
import "../../../ui-styles/cards/Prescription.css";

const DrugRow = (props) => {
    return (
        <Fragment>
            <tr>
                <td>{props.index + 1}</td>
                <td>{props.data.drugname}</td>
                <td>{props.data.takePerDose}{` (${props.data.dose} ${props.data.medicalUnit})`}</td>
                <td>{props.data.doseInDay} ({props.data.whenDose}) </td>
                <td>{props.data.notes}</td>
            </tr>
        </Fragment>
    )
}

export default DrugRow;